import React from 'react';
import { useTheme } from '@mui/material';
import { Box, Text } from 'pounceV2';
import { SettingsGroup, SettingsItem } from '../constants';
import SettingsSidebarItemV3 from './SettingsSidebarItemV3';

interface SettingsSidebarGroupV3Props {
  group: SettingsGroup;
  items: SettingsItem[];
  activeItemId: string | null;
}

const SettingsSidebarGroupV3: React.FC<SettingsSidebarGroupV3Props> = ({
  group,
  items,
  activeItemId,
}) => {
  const {
    palette: { tokens },
  } = useTheme();

  if (items.length === 0) {
    return null;
  }

  return (
    <Box as="section" aria-label={group.label} data-tid={`settings-sidebar-group-${group.id}`}>
      <Box px={4} py={1.5} height={31} display="flex" alignItems="center">
        <Text
          fontSize="x-small"
          fontWeight="medium"
          // Figma → Color/Content (O)/Text/Code/Meta Preprocessor C
          // Keyword/Base (code21[200] = #afc4db). The cool gray-blue
          // sits between the dim helper-text grays and the white
          // selected row, giving the group label its own tier.
          color={tokens.contentO.text.code.meta.preprocessor.c.keyword.base}
          textTransform="uppercase"
          letterSpacing="0.04em"
        >
          {group.label}
        </Text>
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        {items.map(item => (
          <SettingsSidebarItemV3 key={item.id} item={item} isActive={item.id === activeItemId} />
        ))}
      </Box>
    </Box>
  );
};

export default React.memo(SettingsSidebarGroupV3);
